import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { ReferralsCondition } from '@recruitee/http/types';

@Injectable({ providedIn: 'root' })
export class ReferralsConditionsCollectionHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public loadConditions(): Observable<ReferralsCondition[]> {
    return this.httpApi.get(`/referral/conditions`).pipe(map(data => data.conditions));
  }

  public updateConditions(conditions: ReferralsCondition[]): Observable<ReferralsCondition[]> {
    return this.httpApi
      .patch('/referral/conditions', null, {
        conditions,
      })
      .pipe(map(data => data.conditions));
  }
}
